import { render, staticRenderFns } from "./AssignedForms.vue?vue&type=template&id=6c1be9d4"
import script from "./AssignedForms.vue?vue&type=script&lang=js"
export * from "./AssignedForms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports